import template from './ko-field-input-percentage.html';

class PercentageInputComponentVM
{
	constructor(params)
	{
		this.params = params;

		this.readonly = ko.observable();
		this.name = ko.observable(params.name);
		this.label = ko.observable(params.label);
		this.$input = params.$input;
		this.min = ko.observable(0);
		this.max = ko.observable(100);
		this.step = ko.observable(1);
		this.auto_select = ko.observable(params.ui_fields?.auto_select ?? params.auto_select ?? false);
		this.help_text = ko.observable(params.help_text);

		if (params.ui_fields)
		{
			this.min(params.ui_fields.min);
			this.max(params.ui_fields.max);
			this.step(params.ui_fields.step);
		}
		else
		{
			if (params.min)
				this.min(params.min);
			if (params.max)
				this.max(params.max);
			if (params.step)
				this.step(params.step);
		}
	}

	// Clamp function to be called on blur
	clamp_value()
	{
		let value = parseFloat(this.$input());
		if (isNaN(value)) return;

		const min = parseFloat(this.min());
		const max = parseFloat(this.max());
		const step = parseFloat(this.step());

		// Clamp to min and max
		if (value < min)
		{
			this.$input(min);
			return;
		}

		if (value > max)
		{
			this.$input(max);
			return;
		}

		const steps_from_min = Math.round((value - min) / step);
		const corrected = min + steps_from_min * step;

		const decimals = (step.toString().split('.')[1] || '').length;
		const rounded = parseFloat(corrected.toFixed(decimals));

		this.$input(rounded);
	};
}


export default {
	name: 'ko-field-input-percentage',
	viewModel: PercentageInputComponentVM,
	module_type: 'ko',
	template: template
}
